var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnsApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 0c13.807 0 25 11.193 25 25S38.807 50 25 50 0 38.807 0 25 11.193 0 25 0z",
    transform: "translate(-56 -606) translate(56 606)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M25.253 16.346c.946 0 2.13-.659 2.836-1.537.64-.796 1.106-1.908 1.106-3.02 0-.15-.014-.302-.04-.425-1.052.04-2.317.727-3.076 1.647-.6.7-1.146 1.798-1.146 2.923 0 .165.027.33.04.385.067.013.173.027.28.027zm-3.33 16.609c1.293 0 1.865-.893 3.477-.893 1.637 0 1.997.865 3.435.865 1.412 0 2.357-1.345 3.25-2.663.998-1.51 1.411-2.992 1.438-3.06-.093-.028-2.797-1.167-2.797-4.365 0-2.773 2.13-4.022 2.25-4.118-1.41-2.087-3.555-2.142-4.14-2.142-1.585 0-2.877.989-3.69.989-.878 0-2.037-.934-3.409-.934-2.61 0-5.26 2.224-5.26 6.424 0 2.608.986 5.367 2.198 7.151 1.038 1.51 1.944 2.746 3.249 2.746z",
    transform: "translate(-56 -606) translate(56 606)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnsApple);
export default __webpack_public_path__ + "static/media/sns_apple.7a08a37549be0d8cef8266b22c63490b.svg";
export { ForwardRef as ReactComponent };